module.exports = __webpack_public_path__ + "img/tour360.ffd1831d.png";